export class Tab {
    constructor(
        public id: string,
        public name: string,
        public image: string,
        public selectedImage: string
    ) {}
}
